import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CountWidgetSettings } from 'app/shared/models/count-widget-settings';
import { StatisticsService } from 'app/shared/services/statistics.service';
import { UserService } from 'app/shared/services/user.service';
import { LabelService } from '../label.service';
import { Subscription } from 'rxjs';
import { Statistic } from 'app/shared/models/statistic';
import { User } from 'app/shared/models/user';
import { OrganisationService } from 'app/shared/services/organisation.service';

@Component({
    selector: 'subject-review-count-widget',
    styles: ['.countwidget{ display:inline !important; }'],
    // tslint:disable-next-line:max-line-length
    // template: '<count-widget class="countwidget" title={{title}} count={{count}} label={{label}} color={{color}} extralabel={{extralabel}} route={{route}}></count-widget>',
    template: '<count-widget class="countwidget" title={{title}} count={{count}} label={{label}} color={{color}} extralabel={{extralabel}} route={{route}}></count-widget>',
})

export class SubjectReviewCountWidgetComponent implements OnInit, OnDestroy {

    // count={{count}} label={{label}} extracount={{extracount}} extralabel={{extralabel}} detail={{detail}} color={{color}} route={{route}}
    _settings: CountWidgetSettings;
    title: string;
    label: string;
    color: string;
    prev: number[];
    count: number;
    detail: string;
    route: string;
    subjectsDueReviewSnapshotStats: Statistic[] = [];
    extralabel: string = "";
    caseOrReferralId: number;
    users: number[] = [];
    statisticsUpdated: Subscription;
    selectedUsersChanged: Subscription;

    @Input() set settings(val: CountWidgetSettings) {
        if (val) {
            const settings = this._settings;
            this._settings = val || new CountWidgetSettings();
            if (this._settings) {
                console.log("Subject review widget input data "+this._settings)
                this._settings.title = (this._settings.title || '').trim();
                this._settings.label = (this._settings.label || '').trim();
                this.caseOrReferralId = this._settings.typeId;
            }

            this.setupWidget();
            this.setUserInfo(); //What does this do?
            this.prev = [];
            if (this._settings) {
                this.updateCounts();
            }
        }
    }

    // added to suppress error messages
    @Input() id;
    @Input() subjectId;
    @Input() processTypeId;

    constructor(private labelService: LabelService, private statisticsService: StatisticsService,
        private userService: UserService, private organisationService: OrganisationService) {
        this.selectedUsersChanged = this.userService.onSelectedUsersChanged.subscribe((users) => {
            this.users = users;
            //console.log(this.users);
            this.updateWidget(users);
        });
        this.statisticsUpdated = this.statisticsService.onStatisticsUpdated.subscribe((_) => { this.prev = []; });
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
        if (this.selectedUsersChanged) {
            this.selectedUsersChanged.unsubscribe();
        }
        if (this.statisticsUpdated) {
            this.statisticsUpdated.unsubscribe();
        }
    }


    updateWidget(users?) {
        if (this._settings) {
            this._settings.users = users;
            this.prev = users;
            this.setUserInfo();
            this.updateCounts();
        }
    }

    setUserInfo() {
        const settings = this._settings
        const users = this.getUsers(settings);
        this.title = settings.title || this.labelService.getDefaultTitle(settings, users);
        this.route = this.getRoute(settings); //TODO

    }
    //TODO TWO FUNC BELOW
    getRoute(settings) {
        const users = this.getUsers(settings);
        let subjectType = "Case";
     
        let route = `/${settings.referralCounts ? 'referrals' : 'subjects'}/${subjectType}/u`;
        let routeUser = 'all';
        if (settings) {
            if (settings.context && (settings.context.length > 0)) {
                const context = this.labelService.getContext(settings.context);
                routeUser = this.getRouteContext(context) || 'all';
                if ((routeUser === 'users') && this.onlyCurrentUser(users)) {
                    routeUser = 'my';
                }
            }
            route += `/${routeUser}`;

            if (settings.filterId > 0) {
              route += '/reviewDays/' + settings.filterId;
            }

            if (settings.organisationId > 0) {
              route += '/' + this.organisationService.getName(settings.organisationId).toLowerCase();
            }
        

        }
        else {
            route += `all`;
        }
        console.log(route)
        return route;
    }

    getRouteContext(context: number[]) {
        const result: string[] = [];
        let altResult = 'all';
        if (context && (context.length > 0)) {
            context.forEach((i) => {
                switch (i) {
                    case -2: altResult = 'managers'; break;
                    case -1: altResult = 'users'; break;
                    case 0: altResult = 'all'; break;
                    default:
                        this.userService.getById(i).subscribe((user: User) => {
                            if (user) {
                                result.push(user.uid);
                            }
                        });
                        break;
                }
            });
            return (result.length > 0) ? result.join(',') : altResult;
        }
    }


    onlyCurrentUser(users: number[]): boolean {
        if (users) {
            return ((users.length === 1) && (users[0] === this.userService.getCurrentUserId()));
        }
        else {
            return false;
        }
    }
    setupWidget() {

        const settings = this._settings;
        this.count = 0;

        this.label = settings ? settings.label || this.labelService.getDefaultCountLabel(settings).toUpperCase() : '';


        this.color = (settings && settings.color) ? settings.color : 'rgb(244, 67, 54)';

        //this.detail = 'More information to go here...';
    }
    //Users / manager id being passed into the widget from the settings
    //If ALL is selected, what should be passed?
    //might need another param for apssing manager ids. 
    //Filter being 

    updateCounts() {
        const settings = this._settings;
        //const context = this.labelService.getContext(settings.context);
        const context = this.labelService.getContext(settings.context);
        const users = this.getUsers(settings)
        this.count = (settings && settings.typeId) ? this.statisticsService.getSubjectsDueReviewSnapshotStat(settings.filterId, settings.referralCounts, users, context, settings.organisationId) : 0;
        //this.count = this.statisticsService.getSubjectsDueReviewSnapshotStat(settings.filterId, settings.referralCounts, users, context);
    }
    getUsers(settings) {//TODO 
        let result = [];
        if (settings) {
            result = settings.users || this.users;
            const context = this.labelService.getContext(settings.context);

            if (context && (context.length > 0) && (context[0] < 1)) {
                result = (this.users.length > 0) ? this.users : (settings.users || []);
            }
            console.log("Get Users Result: " + result)
            return result;
        }
        else {
            console.log("Get Users this.users " + this.users)

            return this.users;
        }
    }



}
